import React from "react";
import PropTypes from "prop-types";
import { Button, Card, Icon } from "semantic-ui-react";
import { DocumentCard } from "@modules/Document/DocumentCard";

export const DocumentLabelsSearchCard = ({
  onClickAddRemoveButton,
  isSelected,
  metadata,
}) => {
  return (
    <Card className="document-label-selection">
      <Card.Content>
        <Button
          icon
          onClick={onClickAddRemoveButton}
          color={isSelected ? "red" : "green"}
          className="document-label-button"
        >
          <Icon name={isSelected ? "minus" : "plus"} />
          {isSelected ? " Remove" : " Add to List"}
        </Button>
        <DocumentCard data={{ metadata: metadata }} />
      </Card.Content>
    </Card>
  );
};

DocumentLabelsSearchCard.propTypes = {
  onClickAddRemoveButton: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  metadata: PropTypes.object.isRequired,
};
